import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=38c6f3f4&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/plugins.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/dashboard/dash_1.css?vue&type=style&index=1&lang=css&"
import style2 from "./Dashboard.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports